import MeetingTypeDetailsHeader from "./MeetingTypeDetailsHeader";

export default MeetingTypeDetailsHeader;
